module.exports = __webpack_public_path__ + "static/media/logo-one-to-one.4be78181.png";